export default {
  fail: 0,
  sending: 1,
  sent: 2,
  complete: 3,
};